<template>
  <ToolTip :label="props.label">
    <IconButton :icon="props.icon" />
  </ToolTip>
</template>

<script setup>
  const props = defineProps({
    label: String,
    icon: String,
  })
</script>

<style></style>
